export default function TrustBar() {
  return (
    <div
      data-testid="trust-bar"
      style={{
        backgroundColor: '#F2EBE0',
        borderTop: '1px solid rgba(139,74,48,0.1)',
        borderBottom: '1px solid rgba(139,74,48,0.1)',
        padding: '14px 20px',
      }}
    >
      <p
        style={{
          textAlign: 'center',
          fontFamily: 'Graphik, sans-serif',
          fontWeight: 500,
          fontSize: '13px',
          color: '#6B5D50',
          letterSpacing: '0.3px',
          margin: 0,
        }}
      >
        Now booking April &amp; May 2026 · Weddings · Birthdays · Corporate events · Hyderabad &amp; Telangana
      </p>
    </div>
  );
}
